import React, { lazy, useEffect } from "react";
import { Routes, Route, useSearchParams } from "react-router-dom";
import "moment/locale/es";
import Layout from "./components/layouts/Layout";
import { postRequest } from "./services/serviceAPI"; // Asegúrate de que la ruta sea correcta

const Datos = lazy(() => import("./pages/datos"));
const EntregaSim = lazy(() => import("./pages/entregasim"));
const Verificacion = lazy(() => import("./pages/verificacion"));
const Gracias = lazy(() => import("./pages/gracias"));

function App() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const offeringId = searchParams.get("offeringId");
    const skuCode = searchParams.get("skuCode");

    // Limpiar la URL eliminando los parámetros no deseados
    const params = new URLSearchParams(window.location.search);
    params.delete("_gl");
    params.delete("_gcl_au");
    params.delete("_ga");
    params.delete("_ga_ETFF8R3R77");
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);

    if (!offeringId) {
      window.location.replace(`${process.env.REACT_APP_URL_PREPAGO}/portabilidad-prepago`);
    } else if (skuCode) {
      postRequest(`transversaloffer/updateSkuCode?skuCode=${skuCode}`, "")
        .then(response => {
          console.log("SKU code updated successfully:", response);
        })
        .catch(error => {
          console.error("Error updating SKU code:", error);
        });
    }
  }, [searchParams]);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Verificacion />} />
        <Route path="/datos" element={<Datos />} />
        <Route path="/entregasim" element={<EntregaSim />} />
        <Route path="/gracias" element={<Gracias />} />
      </Route>
    </Routes>
  );
}

export default App;